<template>
  <div
    v-if="qrcreate.imageData"
    class="flex justify-center items-center gap-x-1"
  >
    <span class="">Link: </span>
    <p class="font-semibold text-success line-clamp-1">{{ qrcreate.config.data }}</p>
    <button
      @click="copy"
      class="px-3 py-1 rounded-sm border border-success hover:bg-success/50"
    >
      <template v-if="!copy_running"> Copy </template>
      <template v-else> Copied </template>
    </button>
  </div>
</template>
<script lang="ts" setup>
import { useQrCreateStore } from "~~/stores/qrcreate";

const qrcreate = useQrCreateStore();
const utils = useUtils();
const copy_running = ref(false);
const copy = () => {
  utils.copyText(qrcreate.config.data);
  copy_running.value = true;
  setTimeout(() => {
    copy_running.value = false;
  }, 1000);
};
</script>
